import { FaPlane, FaShip, FaTruck } from "react-icons/fa"

export const jenisPengiriman = [
    {
        label: "Barang",
        value: "01"
    },
    {
        label: "Uang ke Luar Negeri",
        value: "02"
    },
    {
        label: "Uang ke Indonesia",
        value: "03"
    }
]

export const modaTransportasi = [
    {
        label: (
            <span>
                <FaTruck style={{ marginRight: 8 }} />
                truck
            </span>
        ),
        value: "truck"
    },
    {
        label: (
            <span>
                <FaShip style={{ marginRight: 8 }} />
                Kapal
            </span>
        ),
        value: "boat"
    },
    {
        label: (
            <span>
                <FaPlane style={{ marginRight: 8 }} />
                Pesawat
            </span>
        ),
        value: "plane"
    }
]